import { jsx, jsxs } from "react/jsx-runtime";
import { USER_COLORS, getOwnerWindow, track, useContainer, useEditor } from "@tldraw/editor";
import { Popover as _Popover } from "radix-ui";
import React, { useCallback, useRef, useState } from "react";
import { useUiEvents } from "../../context/events.mjs";
import { useDirection, useTranslation } from "../../hooks/useTranslation/useTranslation.mjs";
import { TldrawUiButton } from "../primitives/Button/TldrawUiButton.mjs";
import { TldrawUiButtonIcon } from "../primitives/Button/TldrawUiButtonIcon.mjs";
import { TldrawUiGrid } from "../primitives/layout.mjs";
const UserPresenceColorPicker = track(function UserPresenceColorPicker2() {
  const editor = useEditor();
  const container = useContainer();
  const msg = useTranslation();
  const dir = useDirection();
  const trackEvent = useUiEvents();
  const rPointing = useRef(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenChange = useCallback((isOpen2) => {
    setIsOpen(isOpen2);
  }, []);
  const value = editor.user.getColor();
  const onValueChange = useCallback(
    (item) => {
      editor.user.updateUserPreferences({ color: item });
      trackEvent("set-color", { source: "people-menu" });
    },
    [editor, trackEvent]
  );
  const {
    handleButtonClick,
    handleButtonPointerDown,
    handleButtonPointerEnter,
    handleButtonPointerUp
  } = React.useMemo(() => {
    const handlePointerUp = () => {
      rPointing.current = false;
      getOwnerWindow(container).removeEventListener("pointerup", handlePointerUp);
    };
    const handleButtonClick2 = (e) => {
      const { id } = e.currentTarget.dataset;
      if (!id) return;
      if (value === id) return;
      onValueChange(id);
    };
    const handleButtonPointerDown2 = (e) => {
      const { id } = e.currentTarget.dataset;
      if (!id) return;
      onValueChange(id);
      rPointing.current = true;
      getOwnerWindow(container).addEventListener("pointerup", handlePointerUp);
    };
    const handleButtonPointerEnter2 = (e) => {
      if (!rPointing.current) return;
      const { id } = e.currentTarget.dataset;
      if (!id) return;
      onValueChange(id);
    };
    const handleButtonPointerUp2 = (e) => {
      const { id } = e.currentTarget.dataset;
      if (!id) return;
      onValueChange(id);
    };
    return {
      handleButtonClick: handleButtonClick2,
      handleButtonPointerDown: handleButtonPointerDown2,
      handleButtonPointerEnter: handleButtonPointerEnter2,
      handleButtonPointerUp: handleButtonPointerUp2
    };
  }, [container, value, onValueChange]);
  return /* @__PURE__ */ jsxs(_Popover.Root, { onOpenChange: handleOpenChange, open: isOpen, children: [
    /* @__PURE__ */ jsx(_Popover.Trigger, { dir, asChild: true, children: /* @__PURE__ */ jsx(
      TldrawUiButton,
      {
        type: "icon",
        className: "tlui-people-menu__user__color",
        style: { color: editor.user.getColor() },
        title: msg("people-menu.change-color"),
        children: /* @__PURE__ */ jsx(TldrawUiButtonIcon, { icon: "color" })
      }
    ) }),
    /* @__PURE__ */ jsx(_Popover.Portal, { container, children: /* @__PURE__ */ jsx(
      _Popover.Content,
      {
        dir,
        className: "tlui-menu tlui-people-menu__user__color-picker",
        align: "start",
        side: "left",
        sideOffset: 8,
        children: /* @__PURE__ */ jsx(TldrawUiGrid, { children: USER_COLORS.map((item) => /* @__PURE__ */ jsx(
          TldrawUiButton,
          {
            type: "icon",
            "data-id": item,
            "data-testid": item,
            "aria-label": item,
            isActive: value === item,
            title: item,
            style: { color: item },
            onPointerEnter: handleButtonPointerEnter,
            onPointerDown: handleButtonPointerDown,
            onPointerUp: handleButtonPointerUp,
            onClick: handleButtonClick,
            children: /* @__PURE__ */ jsx(TldrawUiButtonIcon, { icon: "color" })
          },
          item
        )) })
      }
    ) })
  ] });
});
export {
  UserPresenceColorPicker
};
//# sourceMappingURL=UserPresenceColorPicker.mjs.map
